import { toNumber, WebsocketNewMessageEvent } from '@freelancer/datastore/core';
import {
  MessageApi,
  RichMessageApi,
} from 'api-typings/messages/messages_types';
import { Message } from './messages.model';
import { RichMessage, RichMessageElement } from './rich-message.model';

const transformRichMessage = (
  richMessageApi: RichMessageApi | undefined,
): RichMessage | undefined => {
  if (richMessageApi) {
    // TODO T38296 Remove `any` from reviver in rich message transformation.
    const parsedJSON = JSON.parse(richMessageApi.content, function reviver(
      this: RichMessageElement & { [index: string]: any },
      k: string,
      v,
    ) {
      if (k === 'content-type' || k === 'display-type') {
        const parts = k.split('-');
        const caps = parts
          .slice(1)
          .map((s: string) => `${s[0].toUpperCase()}${s.slice(1)}`)
          .join('');
        this[`${parts[0]}${caps}`] = v;
      } else {
        return v;
      }
    }) as RichMessage;
    if (parsedJSON && parsedJSON.long && parsedJSON.short && parsedJSON.email) {
      return {
        category: richMessageApi.category,
        long: parsedJSON.long.map(e => (e instanceof Array ? e : [e])),
        short: parsedJSON.short.map(e => (e instanceof Array ? e : [e])),
        email: parsedJSON.email,
      };
    }
  }
  return undefined;
};

export function transformMessage(item: MessageApi): Message {
  const attachments = item.attachments
    ? item.attachments.map(a => a.filename)
    : [];
  return {
    id: item.id,
    attachments,
    clientMessageId: toNumber(item.client_message_id),
    fromUser: item.from_user,
    message: item.message,
    messageId: item.id,
    messageSource: item.message_source,
    richMessage: transformRichMessage(item.rich_message),
    threadId: item.thread_id,
    timeCreated: item.time_created * 1000,
  };
}

export function transformWebsocketMessage(
  payload: WebsocketNewMessageEvent,
): Message {
  const item = payload.data;
  return {
    id: item.id,
    attachments: [],
    clientMessageId: toNumber(item.client_message_id),
    fromUser: item.from_user,
    message: item.message,
    messageId: item.id,
    messageSource: item.message_source,
    parentId: item.parent_id,
    richMessage: transformRichMessage(item.rich_message),
    threadId: item.thread_id,
    timeCreated: item.time_created * 1000,
  };
}



// WEBPACK FOOTER //
// ./src/@freelancer/datastore/messages/messages.transformers.ts